import { render, staticRenderFns } from "./DeliveriesPerPerson.vue?vue&type=template&id=08c85945&"
import script from "./DeliveriesPerPerson.vue?vue&type=script&lang=js&"
export * from "./DeliveriesPerPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports